import gql from 'graphql-tag';

export const GET_FRIEND_LIST = gql`
    query($member_no: String!, $limit: Int!, $offset: Int!) {
        getGolfFriendList(member_no: $member_no, limit: $limit, offset: $offset){
            GolfFriendList{
                id
                friend_member_no
                family_name
                given_name
                email
                mobile_number
                members_exists
            }
            totalCount
        }
    }
`;

export const GET_MEMBER_BY_EMAIL = gql`
    query($email: String!){
        getMemberByEmailFromWeb(email: $email){
            member_no
            family_name
            given_name
            mobile_number
        }
    }
`;

export const GET_MEMBER_BY_MOBILE_NUMBER = gql`
    query($mobile_number: String!){
        getMemberByMobileNumberFromWeb(mobile_number: $mobile_number){
            member_no
            family_name
            given_name
            email
        }
    }
`;

export const REGIST_GOLF_FRIEND = gql`
    mutation(
        $member_no: String!
        $friend_member_no: String
        $friend_family_name: String
        $friend_given_name: String
        $email: String
        $mobile_number: String
        $registedMemberFlag: Boolean!
        $family_name: String
        $given_name: String
    ){
        registGolfFriend(
            member_no: $member_no
            friend_member_no: $friend_member_no
            friend_family_name: $friend_family_name
            friend_given_name: $friend_given_name
            email: $email
            mobile_number: $mobile_number
            registedMemberFlag: $registedMemberFlag
            family_name: $family_name
            given_name: $given_name
        ){
            result
        }
    }`;

export const UPDATE_GOLF_FRIEND = gql`
    mutation(
        $id: ID!
        $member_no: String!
        $friend_member_no: String
        $friend_family_name: String
        $friend_given_name: String
        $email: String
        $mobile_number: String
        $family_name: String
        $given_name: String
    ){
        updateGolfFriend(
            id: $id
            member_no: $member_no
            friend_member_no: $friend_member_no
            friend_family_name: $friend_family_name
            friend_given_name: $friend_given_name
            email: $email
            mobile_number: $mobile_number
            family_name: $family_name
            given_name: $given_name
        ){
            result
        }
    }`;

export const DELETE_GOLF_FRIEND = gql`
    mutation($id: ID!){
        deleteGolfFriend(id: $id){
            result
        }
    }`;

export const GET_SELECTED_FRIEND_LIST = gql`
query(
  $friend_member_no: Int
) {
    getFriendList (
        friend_member_no: $friend_member_no
  ){
    GolfFriendList{
        family_name
        given_name
        email
        mobile_number
    }
  }
}
`;

export const GET_FRIEND_PROFILE = gql`
    query($email: String){
        getFriendProfile(
            email: $email
    ){
        Friend{
            member_no
            family_name
            given_name
            gender
            era
            profile
            score_level
            nickname
        }
    }
}
`;

export const CHECK_TMP_FRIEND_TOKEN = gql`
    query(
        $token: String
        $id: String
        $member_no: String!
    ){
        checkTmpFriendToken(
            token: $token
            id: $id
            member_no: $member_no
    ){
        resultCode
        message
    }
}
`;

export const APPROVAL_GOLF_FRIEND = gql`
    mutation(
        $token: String
        $id: String
        $member_no: String!
    ){
        approvalGolfFriend(
            token: $token
            id: $id
            member_no: $member_no
        ){
            result
        }
    }`;

export const DELETE_TMP_GOLF_FRIEND = gql`
    mutation($token: String!){
        deleteTmpGolfFriend(token: $token){
            result
        }
    }`;